var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "shop-subset-selection",
    class: {
      'shop-subset-selection--disabled': _vm.disabled
    }
  }, [_vm.showParentBranches ? [_vm.isFetchingOptions ? _c('div', {
    staticClass: "shop-subset-selection__loading-wrapper mb-2"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _vm.usesSpecificParentBranchProvider ? _c('AreaSelection', {
    ref: "parent-area-selection",
    staticClass: "mb-2",
    attrs: {
      "branch-provider": _vm.parentBranchProvider,
      "show-branch-code": _vm.showBranchCode,
      "placeholder": "請選擇區域",
      "api-source": _vm.apiSource,
      "disabled": _vm.disabled
    },
    on: {
      "selected": _vm.handleSpecificParentBranchSelected,
      "selectedNull": _vm.handleSpecificParentBranchSelectedNull,
      "childrenAreUpdated": _vm.handleSpecificParentChildrenUpdated
    },
    model: {
      value: _vm.selectedParentBranchId,
      callback: function callback($$v) {
        _vm.selectedParentBranchId = $$v;
      },
      expression: "selectedParentBranchId"
    }
  }) : _c('SharedSelect', {
    staticClass: "mb-2",
    attrs: {
      "options": _vm.formatBranchModelsToOptions(_vm.parentBranchModels),
      "placeholder": "請選擇區域",
      "hasBorder": false,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.handleParentBranchSelected
    },
    model: {
      value: _vm.selectedParentBranchId,
      callback: function callback($$v) {
        _vm.selectedParentBranchId = $$v;
      },
      expression: "selectedParentBranchId"
    }
  })] : _vm._e(), _vm.isFetchingOptions ? _c('div', {
    staticClass: "shop-subset-selection__loading-wrapper"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _c('SharedSelect', {
    attrs: {
      "options": _vm.availableShopOptions,
      "placeholder": _vm.placeholder,
      "hasBorder": false,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.handleShopSelected
    },
    model: {
      value: _vm.selectedShopId,
      callback: function callback($$v) {
        _vm.selectedShopId = $$v;
      },
      expression: "selectedShopId"
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }